<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="tempo_ign_off" class="col-sm-2 control-label">HABILITAR SLEEP:</label>
            <div class="col-sm-2">
                <combo-true-false v-model="config.enable_sleep" />
            </div>
        </div>

        <div class="form-group">
            <label for="tempo_ign_on" class="col-sm-2 control-label">TEMPO SLEEP (min):</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.sleep"  class="form-control" id="sleep" >
            </div>
        </div>

        <div class="form-group">
            <label for="tempo_ign_on" class="col-sm-2 control-label">TEMPO WAKE (hora):</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.wake"  class="form-control" id="wake" >
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-sm btn-success">
                    <i class="fa fa-save"></i> ENVIAR SLEEP & WAKE
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import { Bus } from '../../../../class/bus';
    import ComboTrueFalse from "../../../combos/ComboTrueFalse.vue";
    import {X3tech} from "../../../../class/x3tech";
    export default {
        name: "Sleep",
        components: {ComboTrueFalse},
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await X3tech.sendTempos(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
